<template>
   <div class="modal-mask">
     <div class="screen" @click="close"></div>
     <div class="modal-wrapper">
       <div class="contentForm">
          <div class="form login">
           <h4>Connexion :</h4>
           <div class="line">
             
             
             <label for="email">Email ou Identifiant/Pseudo</label>
             <br />
             <input type="email" name="email" id="email" v-model="identifier" required />
           
             
             <div :class="{'error password': errors.indexOf('nologin') !== -1}">
               <label for="mdp">Mot de passe</label>
               <br />
               <input class="mousetrap" type="password" name="mdp" id="mdp" v-model="password" required />
             </div>
             
             <input type="checkbox" id="scales" name="feature" value="scales" checked />
             <label for="scales">Restez connecté</label>
             <input class="button btnPush mousetrap" name="submit" @click="send" value="Connexion" type="submit" />
             <a class="lost" href="mot-de-passe-oublie">> Mot de passe oublié ?</a>
             <mouse-trap shortcode="enter" @trigger="send" />
             <mouse-trap shortcode="escape" @trigger="close" />
           </div>
           <p>Pas encore de compte ? Vous pouvez en créer un rapidement  et démarrer la quête :
           <br />
           <a href="inscription">> Je crée un compte maintenant</a></p>
        </div>
       </div>
     </div>
   </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import MouseTrap from '@/components/MouseTrap'
  export default {
    components: { MouseTrap },
    data () {
      return {
        identifier: '',
        password: '',
        errors: []
      }
    },
    methods: {
      ...mapActions([ 'signin']),
      close () {
        this.$emit('close')
      },
      async send (e) {
        e.preventDefault();
        
        console.log('test0')
        try {
          await this.signin({ identifier: this.identifier, password: this.password });
          console.log('test1')
          this.close()
          console.log('test2')
          this.$router.push('/carnet-de-bord')
          console.log('test3')
        } catch (ex) {
          this.errors = ['nologin']
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper { width: 100%;display: table-cell; vertical-align: middle; position: relative; }
.modal-enter { opacity: 0; }
.modal-leave-active {  opacity: 0; }

.modal-enter .contentForm,
.modal-leave-active .contentForm {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
    
.contentForm {
  width: 100%;
  max-width: 400px;
  margin: 0 0 0 -200px;
  left: 50%;
  top: 200px;
  color: #fff;
  font-family: 'blogger_sansregular';
  text-align: center;
  background: #492e97;
  position: absolute;
  border-radius: 30px;
  padding: 20px;
  z-index: 100;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}

.contentForm:before {
  content: '';
  width: 275px;
  height: 180px;
  display: block;
  background: transparent url('~@/assets/images/mascotte-connexion.png') no-repeat 0 0;
  position: absolute;
  top: -110px;
  right: -20px;
}

.open .contentForm {
  top: 10%;
  position: fixed;
}

.contentForm .form {
  width: 100%;
  border-radius: 30px;
  padding: 30px 0px;
  box-shadow: 5px 5px 25px rgba(0,0,0,0.4);
}

.contentForm .form .line {     
  width: 280px;
  height: 350px;
  padding: 20px 0 0;
  margin: auto; 
}
.contentForm .form p {     
  width: 278px;
  padding: 15px 0 0;
  margin: 20px auto 0;
  margin: auto; 
  border-top: 2px solid white;
  font-family: 'blogger_sansregular';
  text-align: left;
  color: white;
  display: block;
  clear: both;
}
.contentForm .form p a { 
  color: #de2128;
  font-family: 'blogger_sansbold';
}   
.contentForm .form p a:hover { 
  text-decoration: underline;
}
.contentForm .form label { 
  color: #fff;
  font-family: 'blogger_sansregular';
  float: left; 
  margin-bottom: 5px; }
  
.contentForm .form input  { 
  border-radius: 10px;
  width: 95%;
  padding: 15px 10px;
  border: 0;
  margin: 5px 0 25px;
}
.contentForm .form [type=checkbox]{ 
  display: inline-block;
  width: auto;
  float: left;
}
.contentForm .form input.button  { 
  width: auto;
  padding: 15px 30px;
  float: left;
  display: block;
  clear: both;
}

.screen {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0,0,0,0.1);
  z-index: 100;
  top: 0;
}

.lost {
  display: inline-block;
  width: 100%;
  float: left;
  margin: 0px 0 10px;
  text-align: left;
  color: #de2128;
  font-family: 'blogger_sansbold';
  text-indent: 0px;
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}
.lost:hover { text-decoration: underline; text-indent: 20px;}

@media (max-width: 400px) {

  .contentForm:before { display: none !important;}
  .contentForm .form { padding: 0 25px 20px;}
  .contentForm .form p { font-size: 14px; width: auto; }
  .contentForm .form .line { height: auto; width: auto;}
  .contentForm .form h4 { display: none;}
  .contentForm .form input { margin: 4px 0 20px; }
  .contentForm {
    width: 100%;
    max-width: 100%;
    margin: 0 0 0 0px;
    left: 0%;
    top: 0%;
  }
  
}
</style>
